<template>
    <v-layout
        class="fill-height"
    >
        <v-navigation-drawer
            class="filter-navigation pt-16"
            :permanent="!$vuetify.breakpoint.smAndDown"
            :absolute="$vuetify.breakpoint.smAndDown"
            v-model="filterDrawer"
            width="300"
        >
            <form
                class="pa-4"
            >
                <v-text-field
                    name="search"
                    v-model="filter.search"
                    :label="$t('bookings.filter.search')"
                    :placeholder="$t('bookings.placeholder.search')"
                    append-icon="mdi-magnify"
                />
                <div
                    class="mb-4"
                >
                    <label
                        class="d-block"
                    >
                        {{ $t('bookings.filter.done') }}
                    </label>
                        <v-btn-toggle>
                            <v-btn
                                :color="filter.done === null ? 'secondary' : ''"
                                @click="filter.done = null"
                            >
                                {{ $t('all') }}
                            </v-btn>
                            <v-btn
                                :color="filter.done === 1 ? 'secondary' : ''"
                                @click="filter.done = 1"
                            >
                                {{ $t('yes') }}
                            </v-btn>
                            <v-btn
                                :color="filter.done === 0 ? 'secondary' : ''"
                                @click="filter.done = 0"
                            >
                                {{ $t('no') }}
                            </v-btn>
                        </v-btn-toggle>
                </div>
                <v-select
                    :label="$t('bookings.filter.state')"
                    v-model="filter.status"
                    :items="states"
                    item-text="label"
                    item-value="value"
                />
                <v-menu
                    v-model="menus.createdFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.createdFrom"
                            :label="$t('bookings.filter.createdFrom')"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.createdFrom"
                        @input="menus.createdFrom = false"
                    />
                </v-menu>
                <v-menu
                    v-model="menus.createdTo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.createdTo"
                            :label="$t('bookings.filter.createdTo')"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.createdTo"
                        @input="menus.createdTo = false"
                    />
                </v-menu>
                <v-menu
                    v-model="menus.departureFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.departureFrom"
                            :label="$t('bookings.filter.arrivalFrom')"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.departureFrom"
                        @input="menus.departureFrom = false"
                    />
                </v-menu>
                <v-menu
                    v-model="menus.departureTo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.departureTo"
                            :label="$t('bookings.filter.arrivalTo')"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.departureTo"
                        @input="menus.departureTo = false"
                    />
                </v-menu>
                <v-btn
                    @click="resetFilter"
                >
                    {{ $t('action.reset') }}
                </v-btn>
            </form>
        </v-navigation-drawer>
        <v-container
            fluid
            class="pt-16"
        >
            <v-row>
                <v-col
                    cols="12"
                >
                    <v-btn
                        @click="filterDrawer = !filterDrawer"
                        class="d-block d-md-none"
                    >
                        Filter
                    </v-btn>
                    <h1>
                        {{ total }} {{ $tc('bookings.headline.enquiry', total) }}
                    </h1>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                >
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="isLoading"
                        :server-items-length="total"
                        :options.sync="options"
                        :footer-props="{itemsPerPageOptions: [10, 15, 30, -1]}"
                    >
                        <template
                            v-slot:item.bookingNumber="{ item }"
                        >
                            <span
                                class="booking-number-text"
                                :title="item.bookingNumber"
                            >
                                {{ item.bookingNumber }}
                            </span>
                        </template>
                        <template
                            v-slot:item.operatorType="{ item }"
                        >
                            {{ getOperatorType(item) }}
                        </template>
                        <template
                            v-slot:item.state="{ item }"
                        >
                            <v-chip
                                :color="getStatusColor(item.state)"
                            >
                              {{ getStatusLabel(item.state) }}
                            </v-chip>
                        </template>
                        <template
                            v-slot:item.ttr="{ item }"
                        >
                            <expiry-countdown
                                :booking="item"
                                v-if="parseInt(item.state) === 0"
                            />
                        </template>
                        <template
                            v-slot:item.bookingType="{ item }"
                        >
                            {{ getTypeLabel(item.bookingType) }}
                        </template>
                        <template
                            v-slot:item.createdAt="{ item }"
                        >
                            {{ new Date(item.createdAt).toLocaleDateString() }}
                        </template>
                        <template
                            v-slot:item.start="{ item }"
                        >
                            <span
                                v-if="!item.offerDate"
                            >
                                {{ new Date(item.start).toLocaleDateString() }}
                            </span>
                            <span
                                v-else
                                style="display:inline-flex;align-items:baseline"
                            >
                                <span>
                                    {{ new Date(item.offerDate).toLocaleDateString() }}
                                </span>
                                <v-tooltip
                                    bottom
                                >
                                    <template
                                        v-slot:activator="{ on, attrs }"
                                    >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            class="pl-2 orange--text"
                                        >
                                            mdi-alert
                                        </v-icon>
                                    </template>
                                    <span>
                                        {{ $t('bookings.oldDepartureWas', { date: new Date(item.start).toLocaleDateString() }) }}
                                    </span>
                                </v-tooltip>
                            </span>
                        </template>
                        <template
                            v-slot:item.lastname="{ item }"
                        >
                            {{item.lastname}}, {{item.firstname}}.
                        </template>
                        <template
                            v-slot:item.priceTotal="{ item }"
                        >
                            <span
                                v-if="!item.offerPrice"
                            >
                                {{ bookingPrice(item) | price }}
                            </span>
                            <span
                                v-else
                                style="display:inline-flex;align-items:baseline"
                            >
                                <span>
                                    {{ (parseFloat(bookingPrice(item)) + parseFloat(item.offerPrice)) | price }}
                                </span>
                                <v-tooltip
                                    bottom
                                >
                                    <template
                                        v-slot:activator="{ on, attrs }"
                                    >
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            class="pl-2 orange--text"
                                        >
                                            mdi-alert
                                        </v-icon>
                                    </template>
                                    <span>
                                        {{ $t('bookings.oldPriceWas', { price: bookingPriceText(item) }) }}
                                    </span>
                                </v-tooltip>
                            </span>
                        </template>
                        <template
                            v-slot:item.inCharge="{ item }"
                        >
                            <in-charge
                                v-model="item.inCharge"
                                :id="item.id"
                            >
                            </in-charge>
                        </template>
                        <template
                            v-slot:item.actions="{ item }"
                        >
                            <v-btn
                                icon
                                :to="{ name: 'BookingsDetail', params: { id: item.bookingNumber } }"
                                v-if="item.state !== 2"
                            >
                                <v-icon
                                    small
                                >
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        <v-footer
            app
        >
            <v-container
                fluid
                class="d-flex"
            >
                <v-spacer/>
                <v-btn-toggle>
                <v-btn
                    color="secondary"
                    :download="`export.csv`"
                    :href="downloadUri"
                >
                    {{ $t('bookings.action.download') }}
                </v-btn>
                <v-btn
                    color="secondary"
                    :download="`export-${new Date().toLocaleDateString('de')}.xls`"
                    @click.prevent="downloadXLS"
                >
                    {{ $t('bookings.action.downloadXLS') }}
                </v-btn>
                </v-btn-toggle>
            </v-container>
        </v-footer>
    </v-layout>
</template>

<script>
    import '@/filter/number';
    import '@/filter/price';
    import '@/filter/time';
    import { mapActions, mapGetters } from "vuex";
    import { BookingsActions } from "@/store/bookings/types";
    import { getBikes } from "@/utils/bike";
    import { debounce } from "debounce";
    import InCharge from "../components/Booking/InCharge";
    import ExpiryCountdown from "../components/Booking/ExpiryCountdown";
    import * as XLSX from 'xlsx/xlsx';

    export default {
        components: {
            InCharge,
            ExpiryCountdown
        },
        mounted() {
            this.loadBookingsDebounce = debounce(this.loadBookings, 500);
        },
        data: () => ({
            filter: {
                search: null,
                done: null,
                status: -1,
                createdFrom: null,
                createdTo: null,
                departureFrom: null,
                departureTo: null,
            },
            menus: {
                createdFrom: false,
                createdTo: false,
                departureFrom: false,
                departureTo: false,
            },
            filterDrawer: false,
            options: {
                sortBy: ['createdAt'],
                sortDesc: [true],
                page: 1,
                itemsPerPage: 10,
            },
        }),
        computed: {
            ...mapGetters({
                items: 'bookings/inquiries',
                isAdmin: 'auth/isAdmin',
                total: 'bookings/totalInquiries',
                isLoading: 'bookings/isLoading',
            }),
            states() {
                return [
                    {
                        value: -1,
                        label: this.$t('all'),
                    },
                    {
                        value: 0,
                        label: this.$t('status.new'),
                    },
                    {
                        value: 1,
                        label: this.$t('status.confirmed'),
                    },
                    {
                        value: 2,
                        label: this.$t('status.declined'),
                    },
                    {
                        value: 3,
                        label: this.$t('status.offer'),
                    },
                    {
                        value: 4,
                        label: this.$t('status.expired'),
                    },
                    {
                        value: 5,
                        label: this.$t('status.turista'),
                    },
                    {
                        value: 6,
                        label: this.$t('status.test'),
                    },
                ];
            },
            headers() {
                let headers = [
                    {
                        text: this.$t('bookings.headers.type'),
                        value: 'bookingType',
                    },
                    {
                        text: this.$t('bookings.headers.received'),
                        value: 'createdAt',
                    },
                    {
                        text: this.$t('bookings.headers.status'),
                        value: 'state',
                    },
                    {
                        text: this.$t('bookings.headers.ttr'),
                        value: 'ttr',
                        sortable: false
                    },
                    {
                        text: this.$t('bookings.headers.tourCode'),
                        value: 'tourCode',
                    },
                    {
                        text: this.$t('bookings.headers.tourName'),
                        value: 'name',
                        width: 250,
                    },
                    {
                        text: this.$t('bookings.headers.arrival'),
                        value: 'start',
                    },
                    {
                        text: this.$t('bookings.headers.guests'),
                        value: 'pax',
                    },
                    {
                        text: this.$t('bookings.headers.name'),
                        value: 'lastname',
                    },
                    {
                        text: this.$t('bookings.headers.totalPrice'),
                        value: 'priceTotal',
                    },
                    {
                        text: this.$t('bookings.headers.inCharge'),
                        value: 'inCharge',
                        width: 150,
                    },
                    {
                        text: '',
                        value: 'actions',
                        sortable: false,
                    },
                ];

                if(this.isAdmin){
                    headers.unshift({
                        text: 'A/V/P',
                        value: 'operatorType',
                    });
                }

                return headers;
            },
            rows(){
                let hasBikes = false;
                let rows = [
                    [
                        'ASI Tourcode',
                        'Tourcode',
                        'Status',
                        'Type',
                        'Tourname',
                        'Received',
                        'Departure',
                        'Guests',
                        'Room Type',
                        'Price',
                    ],
                ];
                if(this.items.some(item=>this.getBikes(item)>0)){
                    hasBikes = true;
                    rows[0].splice(-1,0,'Bikes'); //add Bike col if any booking has bikes
                }
                for(let i = 0, l = this.items.length; i < l; i++) {
                    let bikes = this.getBikes(this.items[i]);
                    rows.push([
                        this.items[i].code,
                        this.items[i].extCode,
                        this.getStatusLabel(this.items[i].state),
                        this.items[i].bookingType,
                        this.items[i].name,
                        this.items[i].createdAt,
                        this.items[i].offerDate ? this.items[i].offerDate : this.items[i].start,
                        this.items[i].pax,
                        this.items[i].roomTypes ? Object.keys(this.items[i].roomTypes).join(', '):'',
                        this.items[i].offerPrice ? this.items[i].offerPrice : this.items[i].priceTotal,
                    ]);
                    if(hasBikes){
                        rows[rows.length-1].splice(-1,0, bikes);
                    }
                }
                return rows;
            },
            downloadUri() {

                return encodeURI(`data:text/csv;charset=utf-8,${this.rows.map(e => e.join(';')).join('\n')}`);
            }
        },

        watch: {
            options: {
                handler() {
                    this.loadBookings();
                },
                deep: true,
            },
            filter: {
                handler() {
                    this.loadBookingsDebounce();
                },
                deep: true,
            },
        },
        methods: {
            ...mapActions({
                load: `bookings/${BookingsActions.LOAD_INQUIRY}`,
            }),
            getBikes,
            getOperatorType:(booking)=>{
                if(booking.asiOriginal==="1"){
                    return "ASI";
                }else if(booking.isBroker === "1"){
                    return "Vermittler";
                }else{
                    return "Partner";
                }
            },
            getStatusColor: (status) => {
                switch (parseInt(status)) {
                    case 0:
                        return 'primary';
                    case 1:
                        return 'green';
                    case 2:
                        return 'red';
                    case 3:
                        return 'orange';
                    case 4:
                    case 5:
                    case 6:
                        return 'grey';
                }

                return '';
            },
            getStatusLabel(status) {
                switch (parseInt(status)) {
                    case 0:
                        return this.$t('status.new');
                    case 1:
                        return this.$t('status.confirmed');
                    case 2:
                        return this.$t('status.declined');
                    case 3:
                        return this.$t('status.offer');
                    case 4:
                        return this.$t('status.expired');
                    case 5:
                        return this.$t('status.turista');
                    case 6:
                        return this.$t('status.test');
                }

                return '';
            },
            getTypeLabel(type) {
                switch (type) {
                    case 'B':
                        return this.$t('bookings.types.b');
                    case 'OA':
                        return this.$t('bookings.types.oa');
                    case 'W':
                        return this.$t('bookings.types.w');
                }

                return '';
            },
            resetFilter: function() {
                this.filter = {
                    search: null,
                    done: null,
                    status: -1,
                    createdFrom: null,
                    createdTo: null,
                    departureFrom: null,
                    departureTo: null,
                };
            },
            loadBookings: function() {
                this.load({
                    options: this.options,
                    filter: this.filter,
                });
            },
            bookingPrice: (item) => {
                if(item.priceTotal === null) {
                    return null;
                }

                if(item.flexPrice > 0){
                    return item.priceTotal - item.flexPrice;
                }else{
                    return parseFloat(item.priceTotal);
                }
            },
            bookingPriceText(item) {
                return this.$options.filters.price(this.bookingPrice(item));
            },
            downloadXLS() {
                // create new Workbook
                let workBook = XLSX.utils.book_new();
                const workSheet = XLSX.utils.aoa_to_sheet(this.rows);
                // enable all worksheet operations that are disabled by default:
                workSheet["!protect"] = {
                    formatCells:false,
                    formatColumns: false,
                    formatRows: false,
                    insertColumns: false,
                    insertRows: false,
                    insertHyperlinks: false,
                    deleteColumns: false,
                    deleteRows: false,
                    sort: false,
                    autoFilter: false,
                    pivotTables: false
                }
                workBook.SheetNames.push("TripMate Export")
                workBook.Sheets["TripMate Export"] = workSheet;
                XLSX.writeFile(workBook, `export-${new Date().toLocaleDateString('de')}.xls`);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .filter-navigation {
        background-color: #F3F3F3;
    }

    .theme--light.v-chip {
        color: white;
    }

    .booking-number-text {
        width: 80px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
    }
</style>
